import { UploadFile } from "antd/lib/upload/interface";

export async function canRunWebP() {
  return new Promise((resolve) => {
    // Create a canvas element
    const canvas = document.createElement("canvas");

    // If the canvas API is not available, resolve the promise with `false`
    if (!canvas.getContext) {
      resolve(false);
      return;
    }

    // Get the canvas context
    const context = canvas.getContext("2d");

    // Create a new image element
    const image = new Image();

    // Define a sample WebP image as a base64 encoded string
    const webpData =
      "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";

    // Set the source of the image element to the sample WebP data
    image.src = webpData;

    // When the image is loaded, check if it's valid
    image.onload = () => {
      if (context) {
        // Try drawing the image on the canvas
        context.drawImage(image, 0, 0);
        // Check if any image data was successfully written to the canvas
        const data = context.getImageData(0, 0, 1, 1).data;
        // Resolve the promise with `true` if data was written, otherwise `false`
        resolve(data[3] !== 0);
      } else {
        resolve(false);
      }
    };

    // If an error occurs (e.g., the image fails to load), resolve the promise with `false`
    image.onerror = () => {
      resolve(false);
    };
  });
}

/**
 *
 * @param file The file to check
 * @param invalidTypes Invalid types to check against (The types will be the extension of the file: png, jpg, gif, etc)
 * @returns
 */
export function isImage(
  file: File | UploadFile<File>,
  invalidTypes?: string[]
) {
  if (!file.type) return false;
  // Check for image types that are not allowed
  if (invalidTypes?.includes(file.type.split("/")[1])) return false;
  return file.type.split("/")[0] === "image";
}
